import { useQuery, UseQueryOptions } from "react-query";
import { IInteractionMessagesGetQueryParameters, IWritingIssue, Route } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { getAllPaginatedItems } from "utilities/get-all-paginated-items";

/**
 * Request writing issues from the backend.
 * @param url             The URL of the request.
 * @param queryParameters Any query parameters to be sent with the request.
 * @returns An array of writing issues.
 */
const requestAllWritingIssues = async (url: string, queryParameters: {}) => {
    const data = await getAllPaginatedItems<IWritingIssue>(url, { params: queryParameters });
    return data;
};

/**
 * A query to get writing issues from the backend.
 * @param queryParameters Optional query parameters to send with the request.
 * @param options         Query options.
 */
export const useAllWritingIssues = <T = IWritingIssue[]>(
    queryParameters: IInteractionMessagesGetQueryParameters = {},
    options: Omit<UseQueryOptions<IWritingIssue[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.WritingIssues;
    return useQuery<IWritingIssue[], AxiosError, T>(
        [url, queryParameters],
        () => requestAllWritingIssues(url, queryParameters),
        options
    );
};
